/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dashworks.rpc.DashworksRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type AppDeleteOption = 'SOFT' | 'HARD' | unhandledEnumCase;

export type ConnectedApp = {
  appName: string;
  appId: number;
  iconUrl?: string;
  displayName?: string;
  createdAt: number;
  status: ConnectedAppStatus;
};

export type ConnectedAppStatus = 'OK' | 'DISCONNECTED' | unhandledEnumCase;

export type ConnectedMcpServer = {
  id: number;
  authenticatorId: string;
  iconUrl?: string;
  displayName?: string;
  appId?: number;
  status?: ConnectedAppStatus;
};

export type DashworksError = {
  errorType: string;
  message: string;
  context?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type DisconnectUserAppRequest = {
  appId: number;
  deleteOption?: AppDeleteOption;
};

export type DisconnectUserAppResponse = { success: boolean };

export type FetchAppParamsRequest = { appId: number };

export type FetchAppParamsResponse = {
  authenticatorId: string;
  scope?: string;
  appName?: string;
  appId: number;
};

export type GetAppIdsRequest = {};

export type GetAppIdsResponse = { appIds: Default<number[]> };

export type GetBreezeConnectorAppIdsRequest = {};

export type GetBreezeConnectorAppIdsResponse = { appIds: Default<number[]> };

export type GetMcpServersByIdsRequest = { mcpServerIds: Default<string[]> };

export type GetMcpServersByIdsResponse = {
  mcpServers: Default<McpServerSummary[]>;
};

export type GetUserConnectedAppsRequest = {};

export type GetUserConnectedAppsResponse = {
  connectedApps: Default<ConnectedApp[]>;
  connectedMcpServers: Default<ConnectedMcpServer[]>;
};

export type McpServerSummary = {
  id: number;
  authenticatorId: string;
  iconUrl?: string;
  displayName?: string;
  appId?: number;
};

export type StoreUserAppSecretRequest = {
  appId: number;
  secretId: string;
  authenticatorId: string;
  userScope?: string;
};

export type StoreUserAppSecretResponse = { success: boolean };

export type TestGimmieCleanupRequest = {
  appNames: Default<string[]>;
  appNamespace: Default<string>;
};

export type TestGimmieCleanupResponse = {
  success: boolean;
  message: Default<string>;
};

export type TestGimmieSetupRequest = {
  appNames: Default<string[]>;
  appNamespace: Default<string>;
  sourcePortalId: Default<number>;
};

export type TestGimmieSetupResponse = {
  connectedApps: Default<ConnectedApp[]>;
  setupStatus: Default<Record<string, string>>;
  totalAttempted: number;
  successfulSetups: number;
  errorMessage?: string;
  testMessage: Default<string>;
};

export type RetrievalEvalGoogleSheetRequest = {
  spreadsheetUrl: string;
  appName: string;
};

/**
 *  Represents a single query for retrieval evaluation with its golden document IDs.
 */
export type RetrievalEvalQuery = {
  query: string;
  goldenDocumentIds: Default<string[]>;
  queryId?: string;
};

export type RetrievalEvalRequest = {
  queries: Default<RetrievalEvalQuery[]>;
  appNames: Default<string[]>;
};

/**
 *  Response containing retrieval evaluation results.
 */
export type RetrievalEvalResponse = {
  queryResults: Default<RetrievalEvalResult[]>;
  meanRecall: number;
  perfectMatchRate: number;
  totalQueries: number;
  successfulQueries: number;
};

/**
 *  Result for a single query evaluation.
 */
export type RetrievalEvalResult = {
  query: string;
  queryId?: string;
  foundCount: number;
  totalGoldenCount: number;
  foundDocumentIds: Default<string[]>;
  missedDocumentIds: Default<string[]>;
  recall: number;
};

export type RetrievalEvalSingleRequest = {
  query: string;
  goldenDocumentId: string;
  appName: string;
};

export type FetchAppParamsRequestType = Requestify<FetchAppParamsRequest>;
export type FetchAppParamsResponseType = FetchAppParamsResponse;
export type FetchAppParamsErrorType = DashworksError & HubspotMetadata;
export const fetchAppParamsRpc: ChirpAvroRpcDetails<
  FetchAppParamsRequestType,
  FetchAppParamsResponseType,
  FetchAppParamsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'fetchAppParams',
  auth: 'app',
  fingerprint: 'YWt5zaxsXwhZIT_P_vIs6MFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type StoreUserAppSecretRequestType =
  Requestify<StoreUserAppSecretRequest>;
export type StoreUserAppSecretResponseType = StoreUserAppSecretResponse;
export type StoreUserAppSecretErrorType = DashworksError & HubspotMetadata;
export const storeUserAppSecretRpc: ChirpAvroRpcDetails<
  StoreUserAppSecretRequestType,
  StoreUserAppSecretResponseType,
  StoreUserAppSecretErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'storeUserAppSecret',
  auth: 'app',
  fingerprint: '-DR61q9MQT2DBtEzbRG2VcFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetAppIdsRequestType = Requestify<GetAppIdsRequest>;
export type GetAppIdsResponseType = GetAppIdsResponse;
export type GetAppIdsErrorType = DashworksError & HubspotMetadata;
export const getAppIdsRpc: ChirpAvroRpcDetails<
  GetAppIdsRequestType,
  GetAppIdsResponseType,
  GetAppIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getAppIds',
  auth: 'app',
  fingerprint: 'V2ATleAtWU7waHhvzq7C8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetBreezeConnectorAppIdsRequestType =
  Requestify<GetBreezeConnectorAppIdsRequest>;
export type GetBreezeConnectorAppIdsResponseType =
  GetBreezeConnectorAppIdsResponse;
export type GetBreezeConnectorAppIdsErrorType = DashworksError &
  HubspotMetadata;
export const getBreezeConnectorAppIdsRpc: ChirpAvroRpcDetails<
  GetBreezeConnectorAppIdsRequestType,
  GetBreezeConnectorAppIdsResponseType,
  GetBreezeConnectorAppIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getBreezeConnectorAppIds',
  auth: 'app',
  fingerprint: 'EejPgmK4f3su-UE8pdz31MFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUserConnectedAppsRequestType =
  Requestify<GetUserConnectedAppsRequest>;
export type GetUserConnectedAppsResponseType = GetUserConnectedAppsResponse;
export type GetUserConnectedAppsErrorType = DashworksError & HubspotMetadata;
export const getUserConnectedAppsRpc: ChirpAvroRpcDetails<
  GetUserConnectedAppsRequestType,
  GetUserConnectedAppsResponseType,
  GetUserConnectedAppsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getUserConnectedApps',
  auth: 'app',
  fingerprint: 'u6Hgot8FgezxAS-o3S6DoMFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetMcpServersByIdsRequestType =
  Requestify<GetMcpServersByIdsRequest>;
export type GetMcpServersByIdsResponseType = GetMcpServersByIdsResponse;
export type GetMcpServersByIdsErrorType = DashworksError & HubspotMetadata;
export const getMcpServersByIdsRpc: ChirpAvroRpcDetails<
  GetMcpServersByIdsRequestType,
  GetMcpServersByIdsResponseType,
  GetMcpServersByIdsErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'getMcpServersByIds',
  auth: 'app',
  fingerprint: 'F5GO833_Z_StMMS-XV9b1sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DisconnectUserAppRequestType = Requestify<DisconnectUserAppRequest>;
export type DisconnectUserAppResponseType = DisconnectUserAppResponse;
export type DisconnectUserAppErrorType = DashworksError & HubspotMetadata;
export const disconnectUserAppRpc: ChirpAvroRpcDetails<
  DisconnectUserAppRequestType,
  DisconnectUserAppResponseType,
  DisconnectUserAppErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'disconnectUserApp',
  auth: 'app',
  fingerprint: 'Ap_0dmh8bkLw91e8oK9VdcFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type TestGimmieSetupRequestType = Requestify<TestGimmieSetupRequest>;
export type TestGimmieSetupResponseType = TestGimmieSetupResponse;
export type TestGimmieSetupErrorType = DashworksError & HubspotMetadata;
export const testGimmieSetupRpc: ChirpAvroRpcDetails<
  TestGimmieSetupRequestType,
  TestGimmieSetupResponseType,
  TestGimmieSetupErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'testGimmieSetup',
  auth: 'app',
  fingerprint: 'rVbbTlhpACCxeXk2Jy2h_sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type TestGimmieCleanupRequestType = Requestify<TestGimmieCleanupRequest>;
export type TestGimmieCleanupResponseType = TestGimmieCleanupResponse;
export type TestGimmieCleanupErrorType = DashworksError & HubspotMetadata;
export const testGimmieCleanupRpc: ChirpAvroRpcDetails<
  TestGimmieCleanupRequestType,
  TestGimmieCleanupResponseType,
  TestGimmieCleanupErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'testGimmieCleanup',
  auth: 'app',
  fingerprint: 'YRjUnma4W8czWIR9vuhpjMFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RunRetrievalEvalSingleRequestType =
  Requestify<RetrievalEvalSingleRequest>;
export type RunRetrievalEvalSingleResponseType = RetrievalEvalResponse;
export type RunRetrievalEvalSingleErrorType = DashworksError & HubspotMetadata;
export const runRetrievalEvalSingleRpc: ChirpAvroRpcDetails<
  RunRetrievalEvalSingleRequestType,
  RunRetrievalEvalSingleResponseType,
  RunRetrievalEvalSingleErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'runRetrievalEvalSingle',
  auth: 'app',
  fingerprint: 'J6KqrEs8JqCV0JaWk37N8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RunRetrievalEvalRequestType = Requestify<RetrievalEvalRequest>;
export type RunRetrievalEvalResponseType = RetrievalEvalResponse;
export type RunRetrievalEvalErrorType = DashworksError & HubspotMetadata;
export const runRetrievalEvalRpc: ChirpAvroRpcDetails<
  RunRetrievalEvalRequestType,
  RunRetrievalEvalResponseType,
  RunRetrievalEvalErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'runRetrievalEval',
  auth: 'app',
  fingerprint: 'qoqNZZJPqpOV0JaWk37N8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RunRetrievalEvalFromGoogleSheetRequestType =
  Requestify<RetrievalEvalGoogleSheetRequest>;
export type RunRetrievalEvalFromGoogleSheetResponseType = RetrievalEvalResponse;
export type RunRetrievalEvalFromGoogleSheetErrorType = DashworksError &
  HubspotMetadata;
export const runRetrievalEvalFromGoogleSheetRpc: ChirpAvroRpcDetails<
  RunRetrievalEvalFromGoogleSheetRequestType,
  RunRetrievalEvalFromGoogleSheetResponseType,
  RunRetrievalEvalFromGoogleSheetErrorType,
  false
> = {
  serviceName: 'com.hubspot.dashworks.rpc.DashworksRpc',
  rpcName: 'runRetrievalEvalFromGoogleSheet',
  auth: 'app',
  fingerprint: '0XczeUTylHKV0JaWk37N8sFCuh5Cor36',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
